<template>
  <v-card outlined class="report-section-card mb-3">
    <v-card-text class="pa-4">
      <div>
        <div class="section-title">Profit & Loss</div>
        <div class="section-subtitle">Profit reports by product and customer</div>
      </div>

      <div class="report-list mt-3">
        <div class="report-item" @click="openDateSelector('profitAndLoss/standard')">
          <div class="report-icon-box"><v-img src="@/assets/Report/deficit.png" /></div>
          <div class="report-item-title">Profit & Loss Standard</div>
          <v-icon color="#94a3b8">mdi-calendar-range</v-icon>
        </div>

        <div class="report-item" @click="openDateSelector('profitAndLoss/byProduct')">
          <div class="report-icon-box"><v-img src="@/assets/Report/business-and-finance.png" /></div>
          <div class="report-item-title">Profit & Loss By Product</div>
          <v-icon color="#94a3b8">mdi-calendar-range</v-icon>
        </div>

        <div class="report-item" @click="openDateSelector('profitAndLoss/byCustomer')">
          <div class="report-icon-box"><v-img src="@/assets/Report/deficit.png" /></div>
          <div class="report-item-title">Profit & Loss By Customer</div>
          <v-icon color="#94a3b8">mdi-calendar-range</v-icon>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "report-profit-and-loss",

  methods: {
    ...mapActions("reportView", ["setDateSelector", "setReportName"]),

    openDateSelector(reportName) {
      this.setReportName(reportName);
      this.setDateSelector(true);
    },
  },
};
</script>

<style scoped>
.report-section-card { border-radius: 20px; background: #ffffff; }
.section-title { font-size: 18px; font-weight: 800; color: #0f172a; }
.section-subtitle { font-size: 13px; color: #64748b; margin-top: 2px; }
.report-list { display: grid; gap: 8px; }
.report-item { display: flex; align-items: center; gap: 12px; padding: 12px; border-radius: 16px; background: #f8fafc; cursor: pointer; transition: 0.2s ease; }
.report-item:hover { background: #eef2ff; }
.report-icon-box { width: 38px; height: 38px; min-width: 38px; border-radius: 12px; background: #ffffff; padding: 7px; display: flex; align-items: center; justify-content: center; }
.report-item-title { flex: 1; font-size: 14px; font-weight: 700; color: #0f172a; }
</style>
